<template>
  <div
    class="el-slider"
    :class="{ 'is-vertical': vertical, 'el-slider--with-input': showInput }"
    role="slider"
    :aria-valuemin="min"
    :aria-valuemax="max"
    :aria-orientation="vertical ? 'vertical': 'horizontal'"
    :aria-disabled="sliderDisabled"
  >
    <el-input-number
      v-if="showInput && !range"
      ref="input"
      v-model="firstValue"
      class="el-slider__input"
      :step="step"
      :disabled="sliderDisabled"
      :controls="showInputControls"
      :min="min"
      :max="max"
      :debounce="debounce"
      :size="inputSize"
      @change="$nextTick(emitChange)"
    />
    <div
      ref="slider"
      class="el-slider__runway"
      :class="{ 'show-input': showInput, 'disabled': sliderDisabled }"
      :style="runwayStyle"
      @click="onSliderClick"
    >
      <div
        class="el-slider__bar"
        :style="barStyle"
      />
      <slider-button-primary
        ref="button1"
        v-model="firstValue"
        :vertical="vertical"
        :is-money="money"
        :tooltip-class="tooltipClass"
        :force-tooltip-open="forceTooltipOpen"
      />
      <slider-button-primary
        v-if="range"
        ref="button2"
        v-model="secondValue"
        :vertical="vertical"
        :is-money="money"
        :tooltip-class="tooltipClass"
        :force-tooltip-open="forceTooltipOpen"
        class="second"
      />
      <template v-if="showStops">
        <div
          v-for="(item, key) in stops"
          :key="key"
          class="el-slider__stop"
          :style="vertical ? { 'bottom': item + '%' } : { 'left': item + '%' }"
        />
      </template>
    </div>
  </div>
</template>

<script>
  import { Slider } from 'element-ui';
  import SliderButtonPrimary from './SliderButtonPrimary';

  export default {
    name: 'RangePrimary',
    components: {
      SliderButtonPrimary,
    },
    extends: Slider,
    props: {
      forceTooltipOpen: {
        type: Boolean,
        default: false,
      },
      money: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/MainLeftFilters/RangePrimary.vue